import * as tslib_1 from "tslib";
import { Item } from './item';
var Field = (function (_super) {
    tslib_1.__extends(Field, _super);
    function Field() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Field.prototype.toValue = function () {
        return this.value;
    };
    Object.defineProperty(Field.prototype, "length", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "tag", {
        get: function () {
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "target", {
        get: function () {
            return Item.Absent;
        },
        enumerable: true,
        configurable: true
    });
    Field.prototype.flattened = function () {
        return Item.Absent;
    };
    Field.prototype.header = function (tag) {
        return Item.Absent;
    };
    Field.prototype.headers = function (tag) {
        return undefined;
    };
    Field.prototype.head = function () {
        return Item.Absent;
    };
    Field.prototype.tail = function () {
        return Item.Empty;
    };
    Field.prototype.body = function () {
        return Item.Absent;
    };
    Field.prototype.get = function (key) {
        return Item.Absent;
    };
    Field.prototype.getAttr = function (key) {
        return Item.Absent;
    };
    Field.prototype.getItem = function (index) {
        return Item.Absent;
    };
    Field.prototype.stringValue = function (orElse) {
        return this.value.stringValue(orElse);
    };
    Field.prototype.numberValue = function (orElse) {
        return this.value.numberValue(orElse);
    };
    Field.prototype.booleanValue = function (orElse) {
        return this.value.booleanValue(orElse);
    };
    Field.prototype.withoutKey = function (key) {
        return this;
    };
    Field.prototype.cond = function (thenTerm, elseTerm) {
        thenTerm = Item.of(thenTerm);
        return thenTerm;
    };
    Field.prototype.or = function (that) {
        return this;
    };
    Field.prototype.and = function (that) {
        that = Item.of(that);
        return that;
    };
    Field.prototype.isAliased = function () {
        return false;
    };
    Field.prototype.cast = function (form, orElse) {
        return this.value.cast(form, orElse);
    };
    Field.prototype.coerce = function (form) {
        return this.value.coerce(form);
    };
    Field.of = function (key, value) {
        var name;
        if (typeof key === 'string') {
            name = key;
        }
        else if (key instanceof Item.Text) {
            name = key.value;
        }
        if (name !== undefined && name.charCodeAt(0) === 64) {
            return Item.Attr.of.apply(undefined, arguments);
        }
        else {
            return Item.Slot.of.apply(undefined, arguments);
        }
    };
    Field.IMMUTABLE = 1;
    return Field;
}(Item));
export { Field };
Item.Field = Field;
//# sourceMappingURL=data:application/json;base64,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